<template>
<div class='vx-col w-full mt-4'>
    <misJuegos/>
</div>
</template>
 
<script>
import misJuegos from './misJuegos.vue';
export default {
        components: {misJuegos},
        data() {
                return {};
        },
        created() {},
        mounted() {},
        methods: {}
};
</script>